import type { IQuoteOrigin, Source } from 'apiConnector/quote-loading';
import { quoteLoadingApi } from 'apiConnector/quote-loading';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { openQuoteTabThunk } from 'state/quotes/dashboard/dashboard.thunks';
import type { EpicWithThunk } from 'state/state.common';

export interface LoadQuoteEpicApi {
  retrieveQuoteOrigin(quoteId: string, source?: Source): Observable<IQuoteOrigin>;
}
export function loadQuoteEpic(): EpicWithThunk {
  return (action$, _state$, { navigateTo, httpClient }) => {
    return action$.pipe(
      ofType('WORKSPACE_QUOTE_LOADED'),
      mergeMap(({ externalId, quoteId, workspace, source }) => {
        if (workspace !== undefined && quoteId !== undefined) {
          return of(openQuoteTabThunk(quoteId, externalId, workspace));
        }
        return quoteLoadingApi(httpClient)
          .retrieveQuoteOrigin(externalId, source)
          .pipe(
            mergeMap(origin =>
              of(
                openQuoteTabThunk(
                  origin.quoteId,
                  origin.externalQuoteId,
                  origin.screenMode === 'NewStatic' ? 'static' : 'dynamic',
                ),
              ),
            ),
            catchError(() => {
              navigateTo('/static');
              return EMPTY;
            }),
          );
      }),
    );
  };
}
